module.exports = __webpack_public_path__ + "img/risk_img2.c3e9c231.png";